import moment from 'moment';

class PlataformasTecnologicasRequestInputTransformer {
  getName() {
    return 'ServiciosPlataformasTecnologicas';
  }

  make(data) {
    const { Complemento = {} } = data;

    if (!Complemento.ServiciosPlataformasTecnologicas) {
      return data;
    }

    const ServiciosPlataformasTecnologicas = { ...Complemento.ServiciosPlataformasTecnologicas };

    let { DetallesDelServicio = [] } = ServiciosPlataformasTecnologicas?.Servicios ?? {};

    data.Complemento = {
      ...Complemento,
      ServiciosPlataformasTecnologicas: {
        ...ServiciosPlataformasTecnologicas,
        Servicios: {
          DetallesDelServicio: DetallesDelServicio.map((item) => {
            return {
              ...item,
              FechaServ: moment(item.FechaServ).format('YYYY-MM-DD'),
            };
          }),
        },
      },
    };

    return data;
  }
}

export default PlataformasTecnologicasRequestInputTransformer;
